import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classes", "overrides", "className", "currentStep", "steps", "onClick", "withoutLabels", "labelPlacement"];
import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Steps from 'rc-steps';
import Text from '../../typography/Text';
import Icon from '../../general/Icon';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
var useStyles = createUseStyles(styles, 'Stepper');
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "check",
  size: "medium",
  color: "white"
});
function Stepper(_ref) {
  var children = _ref.children,
    classesProp = _ref.classes,
    overridesProp = _ref.overrides,
    classNameProp = _ref.className,
    currentStep = _ref.currentStep,
    steps = _ref.steps,
    onClick = _ref.onClick,
    _ref$withoutLabels = _ref.withoutLabels,
    withoutLabels = _ref$withoutLabels === void 0 ? false : _ref$withoutLabels,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? 'horizontal' : _ref$labelPlacement,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  // Overrides
  var override = getOverrides(overridesProp, Stepper.overrides);

  // Classes
  var rootClassName = useMemo(function () {
    return classnames(classes.root, classNameProp, _defineProperty({}, classes.withoutLabels, withoutLabels));
  }, [classNameProp, classes.root, classes.withoutLabels, withoutLabels]);
  var stepClassNames = useCallback(function (step, i) {
    var _classnames2;
    return classnames((_classnames2 = {}, _defineProperty(_classnames2, classes.completed, step.isCompleted), _defineProperty(_classnames2, classes.active, i === currentStep), _classnames2));
  }, [classes.active, classes.completed, currentStep]);
  var isHighlighted = useCallback(function (step, i) {
    return step.isCompleted || i === currentStep;
  }, [currentStep]);
  var getIcon = useCallback(function (i) {
    var content = i + 1;
    if (steps[i] && steps[i].isCompleted) {
      content = _ref2;
    }
    var highlighted = isHighlighted(steps[i], i);
    return /*#__PURE__*/React.createElement("span", {
      onClick: highlighted ? function () {
        return onClick(i);
      } : undefined
    }, /*#__PURE__*/React.createElement(Text, {
      type: "body1",
      className: classes.icon
    }, content));
  }, [classes.icon, isHighlighted, onClick, steps]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: rootClassName
  }, override.root), /*#__PURE__*/React.createElement(Steps, _extends({
    current: currentStep,
    labelPlacement: labelPlacement
  }, props), steps.map(function (step, i) {
    var highlighted = isHighlighted(step, i);
    var stepProps = {
      className: stepClassNames(step, i),
      key: "step-".concat(i),
      icon: getIcon(i),
      onClick: highlighted ? function () {
        return onClick(i);
      } : undefined,
      title: withoutLabels ? undefined : /*#__PURE__*/React.createElement(Text, {
        bold: highlighted
      }, step.title)
    };
    return /*#__PURE__*/React.createElement(Steps.Step, stepProps);
  })));
}
Stepper.overrides = ['root', 'rc-steps'];
Stepper.defaultProps = {
  steps: [],
  currentStep: 1,
  labelPlacement: 'horizontal',
  withoutLabels: false
};
process.env.NODE_ENV !== "production" ? Stepper.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    isCompleted: PropTypes.bool
  })),
  currentStep: PropTypes.number,
  onClick: PropTypes.func,
  labelPlacement: PropTypes.string,
  withoutLabels: PropTypes.bool
} : void 0;
export default /*#__PURE__*/memo(Stepper);